/* eslint-disable import/prefer-default-export */
import { Plugins } from '@leverege/plugin';
export const ColumnRendererFactory = Plugins.createFactory('ColumnRenderer', {
  pluginKey: 'renderer',
  strategy: Plugins.ALL
});